/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch(e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = $.cookie = function (key, value, options) {

    // Write

    if (value !== undefined && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires, t = options.expires = new Date();
        t.setTime(+t + days * 864e+5);
      }

      return (document.cookie = [
        encode(key), '=', stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path    ? '; path=' + options.path : '',
        options.domain  ? '; domain=' + options.domain : '',
        options.secure  ? '; secure' : ''
      ].join(''));
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = decode(parts.shift());
      var cookie = parts.join('=');

      if (key && key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) === undefined) {
      return false;
    }

    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };

}));

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

(function($) {

  // Menu
  $('.hamburger').on('click', function(){
    $(this).toggleClass('is-active');
    $('html, body').toggleClass('ovh nav-open');
  });

  $('#mobile-menu .menu > .menu-item-has-children').on('click', function(){
    if ($(this).hasClass('active')) {
      $('#mobile-menu .menu > .menu-item').removeClass('inactive active');
    } else {
      $('#mobile-menu .menu > .menu-item').removeClass('active').addClass('inactive');
      $(this).removeClass('inactive').addClass('active');
      $(this).siblings().find('.sub-menu').slideUp('fast');
    }
    $(this).find('.sub-menu').eq(0).slideToggle('fast');
  });

  $('#mobile-menu .menu .sub-menu > .menu-item').on('click', function(event){
    event.stopPropagation();
  });

  $('#mobile-menu .menu .sub-menu > .menu-item-has-children').on('click', function(event){
    if (!$('#mobile-menu').hasClass('sub-open')) {
      event.preventDefault();
    }
    event.stopPropagation();
    $('#mobile-menu .menu .sub-menu > .menu-item-has-children').removeClass('active');
    $(this).addClass('active');
    $(this).parent('.sub-menu').show();
    $('#mobile-menu').addClass('sub-open');
  });

  $('#mobile-menu .menu > .menu-item-has-children > a').on('click', function(event){
    event.stopPropagation();
  });

  $('.back-link').on('click', function(event){
    event.preventDefault();
    $('#mobile-menu').removeClass('search-open sub-open');
  });

  $('.menu-back').on('click', function(event){
    event.preventDefault();
    $('#main-menu .search-block').fadeOut();
    $('#main-menu .menu').fadeIn();
  });

  $('#main-menu .menu > .menu-item').hover(function(){
    $('#main-menu .menu > .menu-item').removeClass('active').addClass('inactive');
    $(this).removeClass('inactive').addClass('active');
  }, function(){
    $(this).find('.sub-menu').find('.menu-item').removeClass('inactive active');
  });

  $('#main-menu .menu .menu-item:not(.menu-columns) > .sub-menu > .menu-item').hover(function(){
    $(this).siblings().removeClass('active').addClass('inactive');
    $(this).removeClass('inactive').addClass('active');
    if ($(this).hasClass('menu-item-has-children')) {
      $(this).find('.sub-menu').slideToggle();
    }
  });

  // Search

  $('.button-search').on('click', function(){
    $('#mobile-menu').toggleClass('search-open');
  });

  $('.search-form').submit(function(event){
    event.preventDefault();
    var searchTerm = $(this).find('.search-field').val();
    var url = $('.search-form').attr('action');
    if ($('body').hasClass('nav-open')) {
      $('#main-menu .menu').fadeOut();
      $('#main-menu .search-block').fadeIn();
    } else {
      $('#main-search').addClass('active');
    }
    $.ajax({
      url : url,
      type: 'POST',
      data:{
        'action':'ptp_ajax_search',
        'term'  :searchTerm
      },
      beforeSend:function(){
        $('.search-results').fadeOut();
        $('.search-preloader').fadeIn();
      },
      complete: function(){
        $('.search-preloader').fadeOut();
      },
      success:function(result){
        $('.search-results').fadeIn();
        $('.search-list').html(result);
      },
      error: function(){
        $('.search-results').fadeIn().html('Error! Try again');
      }
    });
  });

  $('.search-close').on('click', function(){
    $('#main-search').removeClass('active');
  });

  

  // Home arrow
  $('.home-arrow-down').on('click', function(){
    $('html, body').animate({
      scrollTop: $('.home-wave').offset().top
    }, 600);
  });

  // Accordion
  $(".accordion-title").on("click", function(){
    if($(this).hasClass('active')){
      $(this).removeClass("active");
      $(this).siblings('.accordion-content').slideUp(300);
    } else {
      $(".accordion-title").removeClass("active");
      $(this).addClass("active");
      $('.accordion-content').slideUp(300);
      $(this).siblings('.accordion-content').slideDown(300);
    }
    return false;
  });

  // Popups

  $('.open-news-link').on('click', function(event){
    var winWidth = $(window).width();
    if (winWidth > 1199) {
      event.preventDefault();
      var target = $(this).closest('.news-box').data('popup');
      $('#news-'+target).addClass('active');
      openPopups();
      $(document).on('keydown', function(e){
        if (e.keyCode == 27) {
          closePopups();
        }
      });
    }
  });

  $('.bg-overlay').on('click', function(){
    if ($(this).hasClass('active')) {
      closePopups();
    }
  });

  $('.popup-close').on('click', function(){
    closePopups();
  });

  function openPopups() {
    $('body').addClass('ovh');
    $('.bg-overlay').addClass('active');
  }

  function closePopups() {
    $('body').removeClass('ovh');
    $('.bg-overlay').removeClass('active');
    $('.popup').removeClass('active');
  }

  $(document).on("click", ".other-tags a", function(e){
    e.preventDefault(); 
    var selectedTag = $(this).attr('data-tag'); 
    
    
    $(".other-tags a").removeClass("selected");
    $(this).addClass('selected');
    $(".products .product").hide(); 
    if (selectedTag == "all") 
      $(".products .product").show(200);   
    else
      $(".products .product." + selectedTag).show(200); 
    if (selectedTag == 'english'){
      $.cookie("lang", "english");
      $(".title-english").show();
      $(".title-french").hide();
    }else if(selectedTag == 'french') {
      $.cookie("lang", "french");
      $(".title-english").hide();
      $(".title-french").show();
    }
  });

  
  $(document).on('change', '#e-copy-terms', function(){
    if ($(this).attr('checked') == 'checked'){
      if ($('#product .product-options .purchase-section.multiple input=[type="submit"]').length)
        $('#product .product-options .purchase-section.multiple input=[type="submit"]').attr('disabled', false); 
      if ($('#checkout').length)
        $('#checkout').attr('disabled', false);
    }else{
      if ($('#product .product-options .purchase-section.multiple input=[type="submit"]').length)
        $('#product .product-options .purchase-section.multiple input=[type="submit"]').attr('disabled', true); 
      if ($('#checkout').length)
        $('#checkout').attr('disabled', true);
    }
  });
  var eBookExists = false; 
  $(document).ready(function(){
    if ($("#cart").length) {
      $("#cartform .item .variant_title").map(function(i,d ){
        if($(d).attr('data-variant') == 'E-Book') {
          eBookExists = true; 
        }
      });
      if (eBookExists) {
        $(".e-copy-terms-wrp").css('display', 'flex');
        $('#checkout').attr('disabled', true);
      }
    }

    
    var selectedLang = findGetParameter('lang');
    console.log("cookie", $.cookie('lang'));
    if (selectedLang == "fr") 
      $.cookie('lang', 'french'); 
    else if (selectedLang == null && !$.cookie('lang') )
      $.cookie('lang', 'english'); 
    console.log("cookie", $.cookie('lang'));
    // if ($(".products").length) {
      if ($.cookie('lang') == "english" ) {
        $(".products .product.french").hide();       
        $(".products .product.english").show();       
        $(".other-tags a[data-tag='english']").addClass('selected');
        $(".other-tags a[data-tag='french']").removeClass('selected');
        $(".title-english").show();
        $(".title-french").hide();
      }else if ($.cookie('lang') == "french") {
        $(".products .product.english").hide();       
        $(".products .product.french").show();       
        $(".other-tags a[data-tag='french']").addClass('selected');
        $(".other-tags a[data-tag='english']").removeClass('selected');
        $(".title-english").hide();
        $(".title-french").show();
      }

    // }
  });  
})(jQuery);
